class Room {
  constructor(room) {
    this._id = room.id;
    this._houseId = room.houseId;
    this._payload = room;
  }

  get id() {
    return this._id;
  }

  get houseId() {
    return this._houseId;
  }

  get payload() {
    return this._payload;
  }

  isParent() {
    return false;
  }
}

class ChildRoom extends Room {
  constructor(room, parent) {
    super(room);
    this._parent = parent;
  }

  get parent() {
    return this._parent;
  }
}

class ParentRoom extends Room {
  constructor(roomData) {
    super(roomData);
    this._children = new Set();
  }

  get children() {
    return this._children;
  }

  hasChildFromOtherHouses() {
    for (const child of this._children) {
      if (this._houseId !== child.houseId) {
        return true;
      }
    }

    return false;
  }

  toRender() {
    const output = { ...this._payload, relatedRooms: [] };

    this._children.forEach((child) => {
      output.relatedRooms.push(child.payload);
    });

    return output;
  }

  isParent() {
    return true;
  }
}

export { ChildRoom, ParentRoom };
